<template>
    <el-card class="main-card">
        <template #header>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/purchase/delivery' }">采购到货</el-breadcrumb-item>
                <el-breadcrumb-item>{{ isEdit ? '编辑到货单' : isView ? '查看到货单' : '新增到货单' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </template>

        <el-tabs v-model="activeTab" type="border-card">
            <!-- 基本信息 Tab -->
            <el-tab-pane label="基本信息" name="basic">
                <el-form :model="forms" ref="forms" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="到货单号" prop="billCode">
                                <el-input v-model="forms.billCode" :disabled="true || isEdit || isView"
                                    style="max-width: 220px;"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="关联采购订单" prop="orderBillCode">
                                <el-input v-model="forms.orderBillCode" :disabled="isView" placeholder="多个用逗号分隔"
                                    style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="单据类型" prop="billType" style="width:350px">
                                <el-select v-model="forms.billType" placeholder="请选择" :disabled="isView">
                                    <el-option label="订单到货" value="订单到货" disabled></el-option>
                                    <el-option label="直接到货" value="直接到货"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="制单日期" prop="billDate">
                                <el-date-picker v-model="forms.billDate" type="date" :disabled="isView"
                                    style="width:220px"></el-date-picker>
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="单据状态" prop="status">
                                <el-select v-model="forms.status" placeholder="请选择" disabled style="max-width: 200px;">
                                    <el-option key="0" label="草稿" :value="0"></el-option>
                                    <el-option key="1" label="待审核" :value="1"></el-option>
                                    <el-option key="2" label="已审核" :value="2"></el-option>
                                    <el-option key="3" label="已入库" :value="3"></el-option>
                                    <el-option key="-1" label="已作废" :value="-1"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="所属公司" prop="companyID">
                                <el-tree-select ref="companys" v-model="forms.companyID" :data="companys"
                                    :disabled="!!forms.companyID" @change="companyChange();" clearable check-strictly
                                    :render-after-expand="false" style="width: 280px;" />
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="部门" prop="departmentID">
                                <el-tree-select ref="departments" v-model="forms.departmentID" :data="departments"
                                    clearable check-strictly :render-after-expand="false" style="width:220px"
                                    :disabled="isView" />
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="外部单号" prop="externalNo">
                                <el-input v-model="forms.externalNo" :disabled="isView" placeholder="送货单号等"
                                    style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>


                    <el-row>
                        <el-col :xs="24">
                            <el-form-item label="备注" prop="remark">
                                <el-input v-model="forms.remark" type="textarea" :rows="2"
                                    :disabled="isView"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>

            <!-- 供应商信息 Tab -->
            <el-tab-pane label="供应商信息" name="supplier">
                <el-form :model="forms" ref="supplierForm" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="供应商" prop="supplierCode">
                                <el-select v-model="forms.supplierCode" filterable clearable placeholder="请选择供应商"
                                    :disabled="isView" style="width:220px" @change="supplierChange">
                                    <el-option v-for="s in suppliers" :key="s.supplierCode"
                                        :label="s.supplierName || s.text" :value="s.supplierCode"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <el-form :model="forms" ref="amountForm" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="税率(%)" prop="taxRate">
                                <el-input-number v-model="forms.taxRate" :disabled="isView" :precision="2" :min="0"
                                    :max="100" style="width:220px" @change="calculateTotals"></el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="总数量(货品)">
                                <el-input v-model="forms.totalQuantity" disabled style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="总金额">
                                <el-input v-model="forms.totalAmount" disabled style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="含税总额">
                                <el-input v-model="forms.totalTaxAmount" disabled style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>

            <!-- 到货信息 Tab -->
            <el-tab-pane label="到货信息" name="delivery">
                <el-form :model="forms" ref="deliveryForm" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="预计到货日期" prop="deliveryDate">
                                <el-date-picker v-model="forms.deliveryDate" type="date" :disabled="isView"
                                    style="width:220px"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="收货人" prop="receiverName">
                                <el-input v-model="forms.receiverName" :disabled="isView"
                                    style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="收货日期" prop="receiverDate">
                                <el-date-picker v-model="forms.receiverDate" type="date" :disabled="isView"
                                    style="width:220px"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="收货仓库" prop="storeCode">
                                <el-input v-model="forms.storeCode" :disabled="isView" placeholder="仓库编号"
                                    style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="仓库名称" prop="storeName">
                                <el-input v-model="forms.storeName" :disabled="isView" style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>
        </el-tabs>

        <div style="text-align:left;">
            <el-button icon="Select" type="primary" @click="submit"
                v-if="!isView && (forms.status == 0 || forms.status == 1 || forms.status == 2)" plain>保存单据</el-button>

            <el-button icon="Finished" type="primary" @click="audit"
                v-if="!isView && forms.status && (forms.status == 0 || forms.status == 1)" plain>审核单据</el-button>

            <el-button icon="Connection" type="primary" @click="generateBatchNumbers" v-if="!isView && forms.status"
                plain>生成货品批次号</el-button>

            <el-button icon="Upload" type="success" @click="convertToStockIn" v-if="!isView && forms.status"
                plain>提交入库</el-button>

            <el-button plain icon="Printer" type="success" v-if="!isView && forms.status" @click="printLabels"
                style="margin-left:10px;">
                打印货品标签
            </el-button>

            <el-button icon="Back" @click="back">返回</el-button>
        </div>

        <!-- 到货明细 -->
        <div style="margin-top: 15px;">
            <el-card>
                <template #header>
                    <div style="display:flex;align-items:center;justify-content:space-between;">
                        <div style="min-width: 450px; ">采购到货明细 （流程：确认回货 > 质检 > 入网/挂签/证书）</div>
                        <!-- 送料加工提示信息 -->
                        <el-alert v-if="hasMaterialProcessing" type="info" :closable="false"
                            style="margin-top: 8px; font-size: 12px;">
                            <template #default>
                                💡 提示：本到货单包含送料加工配件，入库时将自动合并为成品。
                                <span v-for="(group, index) in materialGroups" :key="index" style="margin-left: 10px;">
                                    <el-tag size="small" type="primary">{{ group.groupName }}</el-tag>
                                    <span style="margin: 0 5px;">：</span>
                                    <span>{{ group.parts.join(' + ') }} → {{ group.finalProduct }}</span>
                                </span>
                            </template>
                        </el-alert>
                    </div>
                    <div style="display:flex;align-items:center;justify-content:space-between;">
                        <div
                            style="display:flex;align-items:center;margin-top: 10px;color: var(--el-text-color-secondary); font-size: 13px;">
                            <el-form-item label="关键词:" prop="keyword" style="margin-right: 10px; margin-bottom: 0;">
                                <el-input v-model="keyword" placeholder="请输入关键词搜索" size="small"
                                    style="max-width: 220px;"></el-input>
                            </el-form-item>
                            <el-form-item label="状态:" style="margin-bottom: 0;">
                                <el-select v-model="filterStatus" placeholder="全部状态" size="small" clearable
                                    style="width: 120px;">
                                    <el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="供货工厂:" style="margin-bottom: 0; margin-left: 10px;">
                                <el-select v-model="filterSupplier" placeholder="全部供货工厂" size="small" clearable
                                    filterable style="width: 150px;">
                                    <el-option v-for="s in suppliers" :key="s.supplierCode"
                                        :label="s.supplierName || s.text" :value="s.supplierCode"></el-option>
                                </el-select>
                            </el-form-item>

                        </div>

                        <div>
                            <el-button plain icon="Plus" type="primary" size="small" @click="addDetail" v-if="!isView">
                                新增回货明细
                            </el-button>
                            <el-button plain icon="Position" type="success" size="small"
                                @click="confirmDetail('confirm', '本操作将更新货品的回货状态，确认勾选数据已回货？')" v-if="!isView">
                                确认回货
                            </el-button>

                            <el-dropdown v-if="!isView" style="margin-left:50px;" size="small">
                                <el-button plain icon="Select" type="primary" size="small">
                                    操作质检
                                </el-button>
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item
                                            @click="confirmDetail('qc-pass', '确认勾选货品，本次质检通过？')">质检通过</el-dropdown-item>
                                        <!-- <el-dropdown-item @click="confirmDetail('qc-fail')">质检不通过</el-dropdown-item> -->
                                        <el-dropdown-item divided
                                            @click="confirmDetail('repair', '确认将勾选货品，退回返修？')">退回返修</el-dropdown-item>
                                        <el-dropdown-item
                                            @click="confirmDetail('cancel', '确认将勾选货品，退回退货？')">退回退货</el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>

                            <el-dropdown v-if="!isView" style="margin-left:10px;" size="small">
                                <el-button plain icon="HelpFilled" type="success" size="small">
                                    入网送检
                                </el-button>
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item divided
                                            @click="confirmDetail('cert-send', '确认勾选货品，已送检检测/做证书？')">货品送检</el-dropdown-item>
                                        <el-dropdown-item
                                            @click="confirmDetail('cert-return', '确认勾选货品，已完成送检货品送回？')">送检取货</el-dropdown-item>

                                        <el-dropdown-item divided
                                            @click="confirmDetail('tag-send', '确认勾选货品，送至品牌入网挂签？')">入网挂签</el-dropdown-item>
                                        <el-dropdown-item
                                            @click="confirmDetail('tag-return', '确认勾选货品，已完成品牌入网并取货？')">入网取货</el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>

                            <el-dropdown v-if="!isView" style="margin-left:10px;" size="small">
                                <el-button plain icon="Upload" type="primary" size="small">
                                    批量操作
                                </el-button>
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item divided @click="openImportDialog">批量更新</el-dropdown-item>
                                        <el-dropdown-item @click="downloadTemplate">下载明细</el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>

                        </div>
                    </div>
                </template>

                <!-- 隐藏文件输入：用于直接选择并上传模板（无弹窗） -->
                <input ref="importInput" type="file" accept=".xls,.xlsx" style="display:none"
                    @change="handleImportFile" />

                <el-table ref="detailTable" :data="filteredDetails" stripe border style="width: 100%"
                    @selection-change="onDetailSelectionChange" size="small">
                    <el-table-column type="selection" width="50" align="center"></el-table-column>
                    <el-table-column type="index" label="行号" width="50" align="center"></el-table-column>
                    <el-table-column prop="detailImg" label="图片" width="60">
                        <template v-slot="scope">
                            <el-image style="height: 32px; width: 32px" lazy
                                :src="apiUrl + 'static/code/' + scope.row.detailCode + '?t=0'"
                                :preview-src-list="[apiUrl + 'static/code/' + scope.row.detailCode + '?t=1']">
                                <template #error><img style="width: 100%" src="~@/assets/imgunfine.jpg"
                                        alt="" /></template>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productCode" label="货品信息" width="125">
                        <template #default="{ row }">
                            <el-autocomplete v-model="row.productSearchText"
                                :fetch-suggestions="(queryString, cb) => searchProductAsync(queryString, cb, row)"
                                placeholder="输入货品编号/名称/条码搜索" :disabled="!row._isNew || isView"
                                @select="(item) => handleProductSelect(item, row)" size="small" style="width:100%"
                                :trigger-on-focus="false" :debounce="300">
                                <template #default="{ item }">
                                    <div style="display: flex; justify-content: space-between;">
                                        <span style="font-weight: bold;">{{ item.detailCode }}</span>
                                        <span style="">{{ item.serialCode }}</span>
                                        <span style="color: #8492a6; font-size: 12px;">{{ item.detailName }}</span>
                                    </div>
                                </template>
                            </el-autocomplete>
                        </template>
                    </el-table-column>
                    <el-table-column prop="materialType" label="货品类型" width="90">
                        <template #default="{ row }">
                            <el-tag v-if="row.materialType === '成品'" type="success" size="small">成品</el-tag>
                            <el-tag v-else-if="row.materialType === '配件'" type="warning" size="small">配件</el-tag>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="finalProductGroup" label="回货成品分组" width="130" show-overflow-tooltip>
                        <template #default="{ row }">
                            <el-select v-model="row.finalProductGroup" size="small" 
                                disabled
                                placeholder="分组标识" 
                                style="width:100%">
                                <el-option v-for="group in finalProductGroups" 
                                    :key="group" 
                                    :label="group" 
                                    :value="group">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="isMerged" label="合并状态" width="90">
                        <template #default="{ row }">
                            <el-tag v-if="row.isMerged" type="processing" size="small">🔗 已合并</el-tag>
                            <span v-else-if="row.materialType">-</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="finalProductName" label="合并后成品" width="150" show-overflow-tooltip>
                        <template #default="{ row }">
                            <el-text v-if="row.finalProductName" type="primary" size="small">
                                {{ row.finalProductCode }} - {{ row.finalProductName }}
                            </el-text>
                            <span v-else>-</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="productName" label="货品名称" width="200">
                        <template #default="{ row }">
                            <el-input v-model="row.productName" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productSpec" label="规格型号" width="110">
                        <template #default="{ row }">
                            <el-input v-model="row.productSpec" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="unitName" label="单位" width="70">
                        <template #default="{ row }">
                            <el-input v-model="row.unitName" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="supplierCode" label="供货工厂" width="110">
                        <template #default="{ row }">
                            <el-select v-model="row.supplierCode" filterable clearable placeholder="供应商"
                                :disabled="isView" style="width:100%" size="small" @change="(value) => {
                                    const selected = suppliers.find(s => s.supplierCode === value);
                                    row.supplierName = selected ? selected.supplierName : '';
                                }">
                                <el-option v-for="s in suppliers" :key="s.supplierCode"
                                    :label="s.supplierName || s.text" :value="s.supplierCode"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="supplierProductCode" label="工厂款号" width="110">
                        <template #default="{ row }">
                            <el-input v-model="row.supplierProductCode" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deliveryQuantity" label="到货数量" width="120">
                        <template #default="{ row }">
                            <el-input-number v-model="row.deliveryQuantity" size="small" :disabled="isView"
                                @change="onDetailChange(row)" :precision="2" :min="0"
                                style="width:100%"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="unitPrice" label="单价" width="120">
                        <template #default="{ row }">
                            <el-input-number v-model="row.unitPrice" size="small" :disabled="isView"
                                @change="onDetailChange(row)" :precision="2" :min="0"
                                style="width:100%"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="amount" label="金额" width="70">
                        <template #default="{ row }">
                            <span>{{ row.amount || 0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="taxRate" label="税率(%)" width="120">
                        <template #default="{ row }">
                            <el-input-number v-model="row.taxRate" size="small" :disabled="isView"
                                @change="onDetailChange(row)" :precision="2" :min="0" :max="100"
                                style="width:100%"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="taxTotalAmount" label="含税金额" width="80">
                        <template #default="{ row }">
                            <span>{{ row.taxTotalAmount || 0 }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="qualityStatus" label="质检状态" sortable width="100" fixed="right">
                        <template #default="{ row }">
                            <el-select v-model="row.qualityStatus" size="small" :disabled="isView" style="width:100%">
                                <el-option label="无质检" :value="0"></el-option>
                                <el-option label="等待质检" :value="1"></el-option>
                                <el-option label="质检通过" :value="2"></el-option>
                                <el-option label="未通过" :value="-1"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>

                    <el-table-column prop="certStatus" label="证书状态" sortable width="100" fixed="right">
                        <template #default="{ row }">
                            <el-select v-model="row.certStatus" size="small" :disabled="row.status < 0 || isView"
                                style="width:100%">
                                <el-option label="无需证书" :value="0"></el-option>
                                <el-option label="证书送检" :value="1"></el-option>
                                <el-option label="证书通过" :value="2"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="certNumber" label="证书编号" width="120">
                        <template #default="{ row }">
                            <el-input v-model="row.certNumber" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="certRemark" label="证书备注" width="150">
                        <template #default="{ row }">
                            <el-input v-model="row.certRemark" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>

                    <el-table-column prop="tagBrand" label="品牌名称" width="90">
                        <template #default="{ row }">
                            <el-input v-model="row.tagBrand" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="tagStatus" label="挂签入网" sortable width="100" fixed="right">
                        <template #default="{ row }">
                            <el-select v-model="row.tagStatus" size="small" :disabled="row.status < 0 || isView"
                                style="width:100%">
                                <el-option label="无需挂签" :value="0"></el-option>
                                <el-option label="待挂签" :value="1"></el-option>
                                <el-option label="已挂签" :value="2"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="tagNumber" label="品牌编号" width="120">
                        <template #default="{ row }">
                            <el-input v-model="row.tagNumber" size="small"
                                :disabled="isView || row.tagStatus === 2"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="tagRemark" label="标签备注" width="150">
                        <template #default="{ row }">
                            <el-input v-model="row.tagRemark" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="storeStatus" label="仓库状态" sortable width="100" fixed="right">
                        <template #default="{ row }">
                            <el-select v-model="row.storeStatus" size="small" :disabled="row.status < 0 || isView"
                                style="width:100%">
                                <el-option label="未入库" :value="0"></el-option>
                                <el-option label="提交入库" :value="1"></el-option>
                                <el-option label="已入库" :value="2"></el-option>
                                <el-option label="取消入库" :value="-1"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="storeCode" label="收货仓库" width="120">
                        <template #default="{ row }">
                            <el-input v-model="row.storeCode" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="storeName" label="仓库名称" width="120">
                        <template #default="{ row }">
                            <el-input v-model="row.storeName" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="storeRemark" label="仓库备注" width="150">
                        <template #default="{ row }">
                            <el-input v-model="row.storeRemark" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="batchNo" label="批次号" width="120">
                        <template #default="{ row }">
                            <el-input v-model="row.batchNo" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="serialCode" label="序列号" width="120">
                        <template #default="{ row }">
                            <el-input v-model="row.serialCode" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productionDate" label="生产日期" width="150">
                        <template #default="{ row }">
                            <el-date-picker v-model="row.productionDate" type="date" size="small" :disabled="isView"
                                style="width:100%"></el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column prop="expiryDate" label="有效期至" width="150">
                        <template #default="{ row }">
                            <el-date-picker v-model="row.expiryDate" type="date" size="small" :disabled="isView"
                                style="width:100%"></el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column prop="qualityRemark" label="质检备注" width="150">
                        <template #default="{ row }">
                            <el-input v-model="row.qualityRemark" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="inboundQuantity" label="已入库数量" width="110">
                        <template #default="{ row }">
                            <el-input-number v-model="row.inboundQuantity" size="small" :disabled="true" :precision="2"
                                style="width:100%"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remainQuantity" label="剩余数量" width="80">
                        <template #default="{ row }">
                            <span>{{ row.remainQuantity || 0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" width="200">
                        <template #default="{ row }">
                            <el-input v-model="row.remark" size="small" :disabled="isView"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态" width="90" sortable fixed="right">
                        <template #default="{ row }">
                            <el-tag :type="getStatusType(row.status)" size="small">{{ getStatusLabel(row.status)
                                }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100" fixed="right">
                        <template #default="{ row, $index }">
                            <el-button @click="viewLog(row)" link size="small" type="primary">查看日志</el-button>
                            <!-- <el-button @click="deleteDetailRow($index)" link size="small" type="danger"
                                v-if="!isView">删除</el-button> -->

                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </div>

        <!-- 打印预览对话框 -->
        <el-dialog v-model="printDialogVisible" title="打印预览 - 货品标签" width="800px" :close-on-click-modal="false">
            <div style="max-height: 500px; overflow-y: auto;">
                <div v-for="(item, index) in printPreviewData" :key="index"
                    style="width: 100mm; height: 50mm; padding: 5mm; border: 1px dashed #ccc; margin-bottom: 10px; display: flex; flex-direction: column; justify-content: space-between; background: #fff;">
                    <div
                        style="text-align: center; font-size: 16px; font-weight: bold; border-bottom: 2px solid #333; padding-bottom: 3mm; margin-bottom: 3mm; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                        {{ item.productName || '货品标签' }}
                    </div>
                    <div style="flex: 1; display: grid; grid-template-columns: 1fr 1fr; gap: 2mm; font-size: 11px;">
                        <div style="display: flex; align-items: center;">
                            <span style="font-weight: bold; min-width: 50px;">批次号：</span>
                            <span style="font-size: 13px; font-weight: bold;">{{ item.batchNo }}</span>
                        </div>
                        <div style="display: flex; align-items: center;">
                            <span style="font-weight: bold; min-width: 50px;">款号：</span>
                            <span>{{ item.productCode }}</span>
                        </div>
                        <div style="display: flex; align-items: center;">
                            <span style="font-weight: bold; min-width: 50px;">规格：</span>
                            <span>{{ item.productSpec }}</span>
                        </div>
                        <div style="display: flex; align-items: center;">
                            <span style="font-weight: bold; min-width: 50px;">数量：</span>
                            <span>{{ item.deliveryQuantity }} {{ item.unitName }}</span>
                        </div>
                        <div v-if="item.certNumber" style="display: flex; align-items: center; grid-column: 1 / -1;">
                            <span style="font-weight: bold; min-width: 50px;">证书号：</span>
                            <span style="font-size: 10px;">{{ item.certNumber }}</span>
                        </div>
                        <div v-if="item.tagNumber" style="display: flex; align-items: center;">
                            <span style="font-weight: bold; min-width: 50px;">品牌货号：</span>
                            <span>{{ item.tagNumber }}</span>
                        </div>
                        <div v-if="item.tagBrand" style="display: flex; align-items: center;">
                            <span style="font-weight: bold; min-width: 50px;">品牌名称：</span>
                            <span>{{ item.tagBrand }}</span>
                        </div>
                        <div v-if="item.serialCode" style="display: flex; align-items: center; grid-column: 1 / -1;">
                            <span style="font-weight: bold; min-width: 50px;">序列号：</span>
                            <span style="font-size: 10px;">{{ item.serialCode }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <span>
                    <el-button icon="Close" @click="printDialogVisible = false">取消</el-button>
                    <el-button icon="Printer" type="primary" @click="confirmPrint">确认打印</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 操作日志对话框 -->
        <el-dialog v-model="logDialogVisible" title="操作日志" width="1200px" :close-on-click-modal="false">
            <el-table :data="logList" stripe border style="width: 100%" size="small" v-loading="logLoading">
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="actionName" label="操作名称" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="actionType" label="操作类型" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="beforeStatus" label="操作前状态" width="100" align="center">
                    <template #default="{ row }">
                        <el-tag v-if="row.beforeStatus !== null && row.beforeStatus !== undefined"
                            :type="getStatusType(row.beforeStatus)" size="small">
                            {{ getStatusLabel(row.beforeStatus) }}
                        </el-tag>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="afterStatus" label="操作后状态" width="100" align="center">
                    <template #default="{ row }">
                        <el-tag v-if="row.afterStatus !== null && row.afterStatus !== undefined"
                            :type="getStatusType(row.afterStatus)" size="small">
                            {{ getStatusLabel(row.afterStatus) }}
                        </el-tag>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="beforeQuantity" label="操作前数量" width="100" align="right">
                    <template #default="{ row }">
                        {{ row.beforeQuantity !== null && row.beforeQuantity !== undefined ? row.beforeQuantity : '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="afterQuantity" label="操作后数量" width="100" align="right">
                    <template #default="{ row }">
                        {{ row.afterQuantity !== null && row.afterQuantity !== undefined ? row.afterQuantity : '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="operateRemark" label="操作备注" min-width="150"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="operateUserName" label="操作人" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="operateDate" label="操作时间" width="160" show-overflow-tooltip>
                    <template #default="{ row }">
                        {{ row.operateDate ? $util.fmtDate(new Date(row.operateDate), 'yyyy-MM-dd HH:mm:ss') : '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="ipAddress" label="IP地址" width="130" show-overflow-tooltip></el-table-column>
            </el-table>
            <template #footer>
                <span>
                    <el-button icon="Close" @click="logDialogVisible = false">关闭</el-button>
                </span>
            </template>
        </el-dialog>

    </el-card>
</template>

<script>
import printJS from 'print-js'
import { fetchBillCode, fetchPurchaseSupplier } from '@/api/purchase'
import { searchSkuList } from '@/api/product'

export default {
    name: 'PurchaseDeliveryBill',
    components: {},
    data() {
        return {
            apiUrl: '',
            activeTab: 'basic',
            companys: [],
            departments: [],
            suppliers: [],

            details: [],
            selectedDetails: [],
            importLoading: false,
            printDialogVisible: false,
            printPreviewData: [],
            logDialogVisible: false,
            logLoading: false,
            logList: [],
            currentDetailRow: null,
            forms: {
                billDate: new Date(),
                status: 0,
                totalQuantity: 0,
                totalAmount: 0,
                taxRate: 13,
                taxAmount: 0,
                totalTaxAmount: 0,
                inboundStatus: 0,
                companyID: '',
                companyName: '',
                departmentID: '',
                departmentName: '',
                billCode: '',
                billType: '',
                externalNo: '',
                orderBillCode: '',
                supplierId: '',
                supplierCode: '',
                supplierName: '',
                deliveryDate: null,
                receiverName: '',
                receiverDate: null,
                storeCode: '',
                storeName: '',
                inboundBillCode: '',
                inboundDate: null,
                remark: ''
            },

            keyword: '',
            filterStatus: '',
            filterSupplier: '',
            statusOptions: [
                { value: 0, label: '待回货', type: 'primary' },
                { value: 1, label: '已回货', type: 'success' },
                { value: -10, label: '退回返修', type: 'warning' },
                { value: -20, label: '退回退货', type: 'danger' },
                { value: -1, label: '订单取消', type: 'danger' }
            ],
        }
    },
    computed: {
        isEdit() { return this.$route.query.id && this.$route.query.mode !== 'view' },
        isView() { return this.$route.query.mode === 'view' },
        deliveryId() { return this.$route.query.id },
        filteredDetails() {
            let result = this.details;

            if (this.filterStatus !== '' && this.filterStatus !== null) {
                result = result.filter(item => item.status === this.filterStatus);
            }

            if (this.filterSupplier) {
                result = result.filter(item => item.supplierCode === this.filterSupplier);
            }

            if (this.keyword) {
                const lowerKeyword = this.keyword.toLowerCase();
                result = result.filter(item => {
                    return (item.productCode && item.productCode.toLowerCase().includes(lowerKeyword)) ||
                        (item.productName && item.productName.toLowerCase().includes(lowerKeyword)) ||
                        (item.detailCode && item.detailCode.toLowerCase().includes(lowerKeyword)) ||
                        (item.detailName && item.detailName.toLowerCase().includes(lowerKeyword)) ||
                        (item.serialCode && item.serialCode.toLowerCase().includes(lowerKeyword)) ||
                        (item.batchNo && item.batchNo.toLowerCase().includes(lowerKeyword)) ||
                        (item.certNumber && item.certNumber.toLowerCase().includes(lowerKeyword)) ||
                        (item.tagNumber && item.tagNumber.toLowerCase().includes(lowerKeyword));
                });
            }
            return result;
        },
        // 是否包含送料加工配件
        hasMaterialProcessing() {
            return this.details.some(d => d.materialType && (d.materialType === '配件' || d.materialType === '成品'));
        },
        // 送料加工分组信息
        materialGroups() {
            const groups = {};

            // 按分组收集配件和成品信息
            this.details.forEach(detail => {
                if (detail.finalProductGroup) {
                    if (!groups[detail.finalProductGroup]) {
                        groups[detail.finalProductGroup] = {
                            groupName: detail.finalProductGroup,
                            parts: [],
                            finalProduct: ''
                        };
                    }

                    if (detail.materialType === '配件') {
                        groups[detail.finalProductGroup].parts.push(detail.productName || detail.detailName);
                    } else if (detail.materialType === '成品') {
                        groups[detail.finalProductGroup].finalProduct = detail.productName || detail.detailName;
                    }
                }
            });

            // 转换为数组
            return Object.values(groups).filter(g => g.parts.length > 0 || g.finalProduct);
        },
        // 获取所有成品类型的回货成品分组集合（去重）
        finalProductGroups() {
            const groups = new Set();
            this.details.forEach(detail => {
                if (detail.materialType === '成品' && detail.finalProductGroup) {
                    groups.add(detail.finalProductGroup);
                }
            });
            return Array.from(groups);
        }
    },
    mounted() {
        this.apiUrl = process.env.VUE_APP_BASEURL;
        this.$kaung.init(this.$options.name);

        this.$kaung.companys().then((res) => {
            this.companys = res;
            this.companyChange();
        });

        fetchPurchaseSupplier().then((res) => {
            if (res && res.code === 200) {
                this.suppliers = Array.isArray(res.data) ? res.data : []
            }
        });

        if (this.deliveryId) {
            this.load();
        } else {
            fetchBillCode(this.$options.name).then(res => {
                this.forms.billCode = res.data || ''
            })
        }
    },
    methods: {
        getStatusLabel(status) {
            const option = this.statusOptions.find(item => item.value === status);
            return option ? option.label : '未知';
        },
        getStatusType(status) {
            const option = this.statusOptions.find(item => item.value === status);
            return option ? option.type : 'info';
        },
        // 搜索货品信息
        searchProductAsync(queryString, callback, row) {
            if (!queryString || queryString.trim().length < 2) {
                callback([]);
                return;
            }

            searchSkuList(queryString).then(res => {
                if (res && res.data && res.data.data) {
                    const suggestions = res.data.data;
                    callback(suggestions);
                } else {
                    callback([]);
                }
            }).catch(err => {
                console.error('Product search error:', err);
                callback([]);
            });
        },
        // 选择货品后填充信息
        handleProductSelect(item, row) {
            if (!item) return;

            row.productId = item.id || '';
            row.productCode = item.serialCode || item.brandModelCode || item.factoryModelCode || '';
            row.productName = item.detailName || '';
            row.productSpec = item.detailUnit || '';
            row.productBarcode = item.brandModelCode || item.factoryModelCode || item.serialCode || '';
            row.unitName = item.unitName || '';
            row.detailId = item.id || '';
            row.detailCode = item.detailCode || '';
            row.detailName = item.detailName || '';

            // 设置搜索文本为货品编号，便于显示和编辑
            row.productSearchText = item.detailCode || '';

            row.supplierCode = item.factoryCode || '';
            row.supplierName = item.factoryName || '';
            row.supplierProductCode = item.factoryModelCode || '';

            // 如果已设置订货数量，触发重新计算
            if (row.deliveryQuantity > 0) {
                this.onDetailChange(row);
            }

            this.$message.success('货品信息已填充');
        },
        load() {
            this.$kaung.getone(this.deliveryId).then(res => {
                if (res.code === 200) this.forms = { ...res.data };

                console.log('Loaded forms:', this.forms);
                this.companyChange(this.forms.departmentID);
            });

            this.fetchDetails();
        },
        fetchDetails() {
            this.$kaung.fetch({ url: 'PurchaseDeliveryDetail/GetDetailList', params: { billId: this.deliveryId }, method: 'get' })
                .then(res => {
                    if (res && res.code === 200) {
                        this.details = res.data;
                        this.details.forEach(detail => {
                            detail.productSearchText = detail.productCode || detail.detailCode || '';
                        });
                    }
                })
        },
        addDetail() {
            this.$message.warning('暂不支持新增采购需求外的回货，请重新创建采购需求订单');
            return; // 暂时禁用新增明细功能，避免数据混乱
            // const newDetail = {
            //     id: null,
            //     billId: this.deliveryId || '',
            //     billCode: this.forms.billCode || '',
            //     lineNo: this.details.length + 1,
            //     orderBillCode: '',
            //     orderDetailId: '',
            //     productId: '',
            //     productCode: '',
            //     productName: '',
            //     productSpec: '',
            //     productBarcode: '',
            //     detailId: '',
            //     detailCode: '',
            //     detailName: '',
            //     unitName: '',
            //     deliveryQuantity: 0,
            //     unitPrice: 0,
            //     amount: 0,
            //     taxRate: this.forms.taxRate || 13,
            //     taxAmount: 0,
            //     taxPrice: 0,
            //     taxTotalAmount: 0,
            //     certStatus: 0,
            //     certNumber: '',
            //     certRemark: '',
            //     tagStatus: 0,
            //     tagNumber: '',
            //     tagRemark: '',
            //     storeStatus: 0,
            //     storeCode: this.forms.storeCode || '',
            //     storeName: this.forms.storeName || '',
            //     storeRemark: '',
            //     batchNo: '',
            //     serialCode: '',
            //     productionDate: null,
            //     expiryDate: null,
            //     qualityStatus: 0,
            //     qualityRemark: '',
            //     inboundQuantity: 0,
            //     remainQuantity: 0,
            //     status: 0,
            //     remark: '',
            //     productSearchText: '',
            //     _isNew: true
            // }

            // this.details.push(newDetail)
        },

        submit() {
            // 计算总计
            this.calculateTotals();

            // 首先验证表单
            this.$refs.forms.validate((valid) => {
                if (!valid) {
                    this.$message.error('请完善必填信息');
                    return false;
                }

                // 验证明细数据
                if (!this.details || this.details.length === 0) {
                    this.$message.error('请至少添加一条采购明细');
                    return false;
                }

                // 验证明细必填字段
                for (let i = 0; i < this.details.length; i++) {
                    const detail = this.details[i];
                    if (!detail.productCode || !detail.productName) {
                        this.$message.error(`第 ${i + 1} 行：货品编号和货品名称不能为空`);
                        return false;
                    }
                    if (!detail.deliveryQuantity || detail.deliveryQuantity <= 0) {
                        this.$message.error(`第 ${i + 1} 行：数量必须大于0`);
                        return false;
                    }
                }

                // 保存数据
                this.$kaung.post({ url: '/' + this.$options.name + '/ModifyForms', data: { master: this.forms, details: this.details } }).then(res => {
                    if (res.code === 200) {
                        this.$message({ message: res.content, type: res.type });
                        this.back();
                    }
                }).catch(err => {
                    this.$message.error('提交失败：' + (err.message || '未知错误'));
                });
            });
        },
        audit() {
            this.$confirm('确认单据审核通过, 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
                .then(() => {
                    this.$kaung.fetch({ url: '/' + this.$options.name + '/Audit', params: { id: this.deliveryId } }).then(res => {
                        if (res.code === 200) {
                            this.$message({ message: res.content, type: res.type });
                            this.back();
                        }
                    }).catch(err => {
                        this.$message.error('审核失败：' + (err.message || '未知错误'));
                    });
                })
        },

        convertToStockIn() {
            const billCode = this.forms.billCode

            // 验证单据状态（只有已审核的单据才能生成入库单）
            if (this.forms.status !== 2) {
                this.$message({ message: '只有已审核的到货单才能生成入库单', type: 'warning' })
                return
            }

            // 确认操作
            this.$confirm(
                `确认将到货单【${billCode}】生成入库单吗？`,
                '生成入库单',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).then(() => {
                // 调用后端接口，detailIds 传递空数组
                this.$kaung.fetch({
                    url: `/${this.$options.name}/ConvertToStockIn`,
                    method: 'post',
                    params: { billCode: billCode },
                    data: [] // detailIds 传递空数组
                }).then(res => {
                    if (res && res.code === 200) {
                        this.$message({
                            message: res.content || '入库单生成成功',
                            type: 'success'
                        })
                        this.load()
                    } else {
                        this.$message.error(res.content || res.message || '生成入库单失败')
                    }
                }).catch(err => {
                    console.error('ConvertToStockIn error:', err)
                    this.$message.error('生成入库单失败，请稍后重试')
                })
            }).catch(() => {
                // 用户取消操作
            })
        },
        generateBatchNumbers() {
            const billCode = this.forms.billCode

            // 验证单据状态
            if (!this.forms.status || this.forms.status < 0) {
                this.$message({ message: '单据状态无效，无法生成批次号', type: 'warning' })
                return
            }

            // 验证是否有明细数据
            if (!this.details || this.details.length === 0) {
                this.$message({ message: '没有明细数据，无法生成批次号', type: 'warning' })
                return
            }

            // 确认操作
            this.$confirm(
                `确认为到货单【${billCode}】的批次号/货号为空的货品生成批次号吗？`,
                '系统自动生成货品批次号',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).then(() => {
                // 调用后端接口，detailIds 传递空数组
                this.$kaung.fetch({
                    url: `/${this.$options.name}/GenerateBatchNumbers`,
                    method: 'post',
                    params: { billCode: billCode },
                    data: [] // detailIds 传递空数组
                }).then(res => {
                    if (res && res.code === 200) {
                        this.$message({
                            message: res.content || '批次号生成成功',
                            type: 'success'
                        })
                        // 刷新明细数据
                        this.fetchDetails()
                    } else {
                        this.$message.error(res.content || res.message || '生成批次号失败')
                    }
                }).catch(err => {
                    console.error('GenerateBatchNumbers error:', err)
                    this.$message.error('生成批次号失败，请稍后重试')
                })
            }).catch(() => {
                // 用户取消操作
            })
        },
        back() { this.$router.back() },

        companyChange(departmentID) {
            this.forms.departmentID = departmentID || '';
            this.departments = [];
            var that = this;
            console.log('companyChange', this.forms.companyID);
            if (this.forms.companyID) {
                this.$kaung.departments(this.forms.companyID).then((res) => {
                    that.departments = res;
                    console.log('departmentID', this.forms.departmentID);
                });
            }
        },

        supplierChange() {
            const supplier = this.suppliers.find(s => s.supplierCode === this.forms.supplierCode);
            if (supplier) {
                this.forms.supplierId = supplier.id || '';
                this.forms.supplierName = supplier.supplierName || supplier.text || '';
            }
        },

        onDetailChange(row) {
            const quantity = Number(row.deliveryQuantity) || 0;
            const price = Number(row.unitPrice) || 0;
            const taxRate = Number(row.taxRate) || 0;

            // 计算金额（未税）
            row.amount = (quantity * price).toFixed(2);

            // 计算税额
            row.taxAmount = (row.amount * taxRate / 100).toFixed(2);

            // 计算含税单价
            row.taxPrice = (price * (1 + taxRate / 100)).toFixed(2);

            // 计算含税金额
            row.taxTotalAmount = (parseFloat(row.amount) + parseFloat(row.taxAmount)).toFixed(2);

            // 计算剩余数量
            row.remainQuantity = quantity - (row.inboundQuantity || 0);

            // 重新计算总计
            this.calculateTotals();
        },

        calculateTotals() {
            let totalQty = 0;
            let totalAmt = 0;
            let totalTaxAmt = 0;

            this.details.forEach(detail => {
                totalQty += Number(detail.deliveryQuantity) || 0;
                totalAmt += Number(detail.amount) || 0;
                totalTaxAmt += Number(detail.taxTotalAmount) || 0;
            });

            this.forms.totalQuantity = totalQty.toFixed(2);
            this.forms.totalAmount = totalAmt.toFixed(2);
            this.forms.taxAmount = (totalTaxAmt - totalAmt).toFixed(2);
            this.forms.totalTaxAmount = totalTaxAmt.toFixed(2);
        },

        deleteDetailRow(index) {
            this.$confirm('确定要删除该明细行吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.details.splice(index, 1);
                this.calculateTotals();
                this.$message({ type: 'success', message: '已删除' });
            }).catch(() => { })
        },
        onDetailSelectionChange(selection) {
            this.selectedDetails = selection || [];
        },
        // 触发文件选择并直接上传（无弹窗）
        openImportDialog() {
            this.$confirm('本次上传将更新覆盖回货单的明细数据，确定上传?', '上传提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (this.$refs.importInput) this.$refs.importInput.click();
            }).catch(() => { })
        },
        handleImportFile(e) {
            const file = e.target.files && e.target.files[0];
            // 清空输入，以便下次选择同一文件也能触发 change
            e.target.value = '';
            if (!file) return;
            // 简单检查扩展名
            const name = (file.name || '').toLowerCase();
            if (!(name.endsWith('.xls') || name.endsWith('.xlsx'))) {
                this.$message.warning('请选择 Excel 文件(.xls 或 .xlsx)');
                return;
            }
            this.importLoading = true;
            const fd = new FormData();
            fd.append(file.name, file);

            this.$kaung.fetch({
                url: '/PurchaseDeliveryDetail/UploadTemplate',
                method: 'post',
                data: fd,
            }).then(res => {
                this.importLoading = false;
                if (res && res.code === 200) {
                    this.$message.success(res.content || '导入成功');
                    this.fetchDetails();
                } else {
                    this.$message.error(res.content || res.message || '导入失败');
                }
            }).catch(err => {
                this.importLoading = false;
                console.error('UploadTemplate error:', err);
                this.$message.error('上传失败，请稍后重试');
            });
        },
        // 下载模板（直接跳转到后端 DownloadTemplate）
        downloadTemplate() {
            const billId = this.deliveryId || '';
            this.$kaung.fetch({
                url: '/PurchaseDeliveryDetail/DownloadTemplate',
                method: 'get',
                params: { billId: billId }
            }).then(res => {
                if (res && res.code === 200) {
                    this.$notify({
                        title: '导出成功',
                        message: res.content,
                        type: 'success',
                        duration: 10000
                    });
                    if (res.data) {
                        window.location.href = process.env.VUE_APP_BASEURL + res.data;
                    } else {
                        this.$message.warning('后端未返回下载地址');
                    }
                } else {
                    this.$message.error(res.content || res.message || '下载模板失败');
                }
            }).catch(err => {
                console.error('DownloadTemplate error:', err);
                this.$message.error('下载模板失败，请稍后重试');
            });
        },
        confirmDetail(operate, title) {
            title = title || '确认操作（' + operate + '）';

            // 获取表格勾选的数据
            let selections = this.selectedDetails || [];
            // 兼容性兜底：尝试通过表格实例方法获取（若存在）
            if ((!selections || selections.length === 0) && this.$refs.detailTable && typeof this.$refs.detailTable.getSelectionRows === 'function') {
                try { selections = this.$refs.detailTable.getSelectionRows() || []; } catch (e) { }
            }

            if (!selections || selections.length === 0) {
                this.$message.warning('请先勾选要确认操作的明细行');
                return;
            }

            // 弹出可输入备注的多行输入框
            this.$prompt('请输入本次操作备注（可选）', title, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputType: 'textarea',
                inputPlaceholder: '请输入备注内容',
                inputPattern: /[\s\S]*/,
                dangerouslyUseHTMLString: false,
            }).then(({ value }) => {
                const remark = value || '';

                // 调用后端批量操作接口，remark 通过 params 传递
                this.$kaung.fetch({
                    url: '/PurchaseDeliveryDetail/BatchOperate',
                    method: 'post',
                    params: {
                        billId: this.deliveryId || '',
                        operate: operate || 'confirm',
                        remark: remark
                    },
                    data: selections
                }).then((res) => {
                    if (res && res.code === 200) {
                        this.$message.success(res.content || '操作成功');
                        // 刷新明细
                        this.fetchDetails();
                    } else {
                        this.$message.error(res.content || res.message || '操作失败');
                    }
                }).catch((err) => {
                    console.error('BatchOperate error:', err);
                    this.$message.error('请求失败，请稍后重试');
                });
            }).catch(() => { /* 用户取消 */ });
        },
        printLabels() {
            // 获取表格勾选的数据
            let selections = this.selectedDetails || [];
            if ((!selections || selections.length === 0) && this.$refs.detailTable && typeof this.$refs.detailTable.getSelectionRows === 'function') {
                try { selections = this.$refs.detailTable.getSelectionRows() || []; } catch (e) { }
            }

            if (!selections || selections.length === 0) {
                this.$message.warning('请先勾选要打印标签的货品明细');
                return;
            }

            // 验证必要字段
            const invalidItems = selections.filter(item => !item.batchNo || !item.productCode);
            if (invalidItems.length > 0) {
                this.$message.warning('部分货品缺少批次号或款号，请先补充批次信息或者自动生成批次信息');
                return;
            }

            // 准备打印预览数据
            this.printPreviewData = selections.map(item => ({
                batchNo: item.batchNo || '',
                productCode: item.productCode || '',
                productName: item.productName || '',
                productSpec: item.productSpec || '',
                certNumber: item.certNumber || '',
                tagNumber: item.tagNumber || '',
                tagBrand: item.tagBrand || '',
                serialCode: item.serialCode || '',
                deliveryQuantity: item.deliveryQuantity || 0,
                unitName: item.unitName || ''
            }));

            // 显示预览对话框
            this.printDialogVisible = true;
        },
        confirmPrint() {
            if (!this.printPreviewData || this.printPreviewData.length === 0) {
                this.$message.warning('没有可打印的数据');
                return;
            }

            // 生成打印HTML
            let printHtml = '';

            this.printPreviewData.forEach((item, index) => {
                printHtml += `
                    <div class="label-item" style="page-break-after: always; width: 100mm; height: 50mm; padding: 5mm; border: 1px dashed #ccc; margin-bottom: 5mm; display: flex; flex-direction: column; justify-content: space-between;">
                        <div style="text-align: center; font-size: 16px; font-weight: bold; border-bottom: 2px solid #333; padding-bottom: 3mm; margin-bottom: 3mm; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                            ${item.productName || '货品标签'}
                        </div>
                        <div style="flex: 1; display: grid; grid-template-columns: 1fr 1fr; gap: 2mm; font-size: 11px;">
                            <div style="display: flex; align-items: center;">
                                <span style="font-weight: bold; min-width: 50px;">批次号：</span>
                                <span style="font-size: 13px; font-weight: bold;">${item.batchNo}</span>
                            </div>
                            <div style="display: flex; align-items: center;">
                                <span style="font-weight: bold; min-width: 50px;">款号：</span>
                                <span>${item.productCode}</span>
                            </div>
                            <div style="display: flex; align-items: center;">
                                <span style="font-weight: bold; min-width: 50px;">规格：</span>
                                <span>${item.productSpec}</span>
                            </div>
                            <div style="display: flex; align-items: center;">
                                <span style="font-weight: bold; min-width: 50px;">数量：</span>
                                <span>${item.deliveryQuantity} ${item.unitName}</span>
                            </div>
                            ${item.certNumber ? `
                            <div style="display: flex; align-items: center; grid-column: 1 / -1;">
                                <span style="font-weight: bold; min-width: 50px;">证书号：</span>
                                <span style="font-size: 10px;">${item.certNumber}</span>
                            </div>
                            ` : ''}
                            ${item.tagNumber ? `
                            <div style="display: flex; align-items: center;">
                                <span style="font-weight: bold; min-width: 50px;">品牌号：</span>
                                <span>${item.tagNumber}</span>
                            </div>
                            ` : ''}
                            ${item.tagBrand ? `
                            <div style="display: flex; align-items: center;">
                                <span style="font-weight: bold; min-width: 50px;">品牌：</span>
                                <span>${item.tagBrand}</span>
                            </div>
                            ` : ''}
                            ${item.serialCode ? `
                            <div style="display: flex; align-items: center; grid-column: 1 / -1;">
                                <span style="font-weight: bold; min-width: 50px;">序列号：</span>
                                <span style="font-size: 10px;">${item.serialCode}</span>
                            </div>
                            ` : ''}
                        </div>
                    </div>
                `;
            });

            // 调用打印
            printJS({
                printable: printHtml,
                type: 'raw-html',
                targetStyles: ['*'],
                style: `
                    @page { size: 100mm 50mm; margin: 0; }
                    body { margin: 0; padding: 0; }
                    .label-item { box-sizing: border-box; }
                    @media print {
                        .label-item { border: none !important; margin: 0 !important; }
                    }
                `
            });

            // 关闭预览对话框
            this.printDialogVisible = false;
        },
        // 查看操作日志
        viewLog(row) {
            if (!row || !row.id) {
                this.$message.warning('明细数据无效');
                return;
            }

            this.currentDetailRow = row;
            this.logDialogVisible = true;
            this.fetchLogList(row.id);
        },
        // 获取操作日志列表
        fetchLogList(detailId) {
            this.logLoading = true;
            this.logList = [];

            this.$kaung.fetch({
                url: '/PurchaseDeliveryAction/GetByDetailId',
                method: 'get',
                params: { detailId: detailId }
            }).then(res => {
                this.logLoading = false;
                if (res && res.code === 200) {
                    this.logList = Array.isArray(res.data) ? res.data : [];
                    if (this.logList.length === 0) {
                        this.$message.info('暂无操作日志');
                    }
                } else {
                    this.$message.error(res.content || res.message || '获取日志失败');
                }
            }).catch(err => {
                this.logLoading = false;
                console.error('GetActionsByDetailId error:', err);
                this.$message.error('获取日志失败，请稍后重试');
            });
        }
    }
}
</script>

<style scoped>
.el-tabs {
    margin-bottom: 20px;
}

:deep(.el-tabs__content) {
    padding: 20px 10px;
}

:deep(.el-tab-pane) {
    min-height: 200px;
}
</style>
